import type { ErrorInfo } from "react";

interface AppErrorLog {
  readonly level: "error";
  readonly errorType: "render";
  readonly code: "UNHANDLED_APPLICATION_ERROR";
}

export const APP_ERROR_LOG: Readonly<AppErrorLog> = Object.freeze({
  level: "error",
  errorType: "render",
  code: "UNHANDLED_APPLICATION_ERROR",
});

export function logAppError(
  error: Error,
  errorInfo: ErrorInfo,
  isDevelopment: boolean = import.meta.env.DEV,
): void {
  if (isDevelopment) {
    console.error(APP_ERROR_LOG, error, errorInfo.componentStack);
    return;
  }

  console.error(APP_ERROR_LOG);
}
